module.exports = __webpack_public_path__ + "img/1.63683ae2.png";